export const onSuccess = { type: 'select', name: 'onSuccess', label: 'On Success', changeProp: 1 };
export const onError = { type: 'select', name: 'onFail', label: 'On Fail', changeProp: 1 };
